import { DailySales } from '@domain/sales/models/DailySales';
import { DailySalesDTO } from '../dto/DailySalesDTO';

export class DailySalesMapper {
    static toModel(dto: DailySalesDTO): DailySales {
        return {
            productId: dto.productId,
            marketplaceConnectionId: dto.marketplaceConnectionId,
            date: new Date(dto.date),
            quantity: dto.quantity,
            anomaly: dto.anomaly
        };
    }

    static toDTO(model: DailySales): DailySalesDTO {
        return {
            productId: model.productId,
            marketplaceConnectionId: model.marketplaceConnectionId,
            date: model.date.toISOString(),
            quantity: model.quantity,
            anomaly: model.anomaly
        };
    }
} 